import { EFeatureFlags } from 'collections/featureFlags';
import { isInYearlyPeriod } from 'utils/date';
import dayjs from 'utils/dayjs';
import { useFeatureEnabled } from 'utils/hooks/useFeatureFlags';

const XMAS_START = '12-01';
const XMAS_END = '01-07';

export const useXmasEnabled = () => {
  const enabled = useFeatureEnabled(EFeatureFlags.XMAS_ENABLED);

  return enabled && isInYearlyPeriod(dayjs(), XMAS_START, XMAS_END);
};
